import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from '../../styles/tabsNav.module.css';

const TabsNav = () => {
    return (
        <div className={styles.tabsContainer}>
            <NavLink
                to="/creatividades/dashboard"
                className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
            >
                Dashboard
            </NavLink>
            <NavLink
                to="/creatividades/equipos"
                className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
            >
                Empresas
            </NavLink>
            <NavLink
                to="/creatividades/encuestas"
                className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
            >
                Encuestas
            </NavLink>
        </div>
    );
};

export default TabsNav;
